import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import AddIcon from '@atlaskit/icon/core/migration/add';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { Props } from './index.tsx';
import messages from './messages.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyAddIssuesToVersion = lazy(() =>
	import(/* webpackChunkName: "async-add-issues-to-version" */ './index').then(
		(module) => module.AddIssuesToVersion,
	),
);

export const AddIssuesToVersion = (props: Props) => {
	const { formatMessage } = useIntl();
	const PlaceholderButton = props.isIssueListFooterButton ? IssueListFooterButton : Button;

	return (
		<Placeholder
			name="add-issues-to-version"
			fallback={
				<PlaceholderButton
					onClick={undefined}
					appearance={props.appearance}
					type="button"
					iconBefore={props.showIcon ? <AddIcon label="" LEGACY_size="small" /> : undefined}
				>
					{formatMessage(
						fg('jira-issue-terminology-update-m4')
							? messages.addButtonIssueTerminologyRefreshM4
							: messages.addButton,
					)}
				</PlaceholderButton>
			}
		>
			<LazyAddIssuesToVersion {...props} />
		</Placeholder>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IssueListFooterButton = styled(Button)({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		alignItems: 'center',
		height: '100%',
		maxHeight: '40px',
		textAlign: 'left',
	},
});
